<template>
  <f7-page>
    <div>
      <f7-navbar
        class="no-shadow"
        :style="appTheme"
      >
        <f7-nav-left name="frmVolcarMercanciaVistaUnidadLogistica-nav-lefth">
          <f7-link @click="NavigateBack()">
            <img
              alt="iconBack"
              src="@/static/icons/back.svg"
            >
          </f7-link>
        </f7-nav-left>
        <f7-nav-title>
          {{ $t('production.dump.logisticUnit.title') }}
        </f7-nav-title>
      </f7-navbar>
      <PCInformacionLineaPunto class="navbar-oscuro-1" />
      <div class="div-001">
        <PCVistaVolcarUL ref="PCVistaVolcarUL" />
      </div>
    </div>
  </f7-page>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import PCInformacionLineaPunto from '@/components/production/traceability/PCInformacionLineaPunto.vue';
import PCVistaVolcarUL from '@/components/production/traceability/PCVistaVolcarUL.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmDumpMerchandiseULView',
  components: {
    PCInformacionLineaPunto,
    PCVistaVolcarUL,

  },
  data() {
    return {
      actualizaMercanciaPCVistaVolcarUL: null, // Contiene la fecha de la ultima actualización.
    };
  },
  computed: {
    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  created() {
    this.ActivarListener();
  },
  beforeUnmount() {
    this.DesactivarListener();
  },
  methods: {
    NavigateBack() {
      f7.views.main.router.back();
    },
    ActivarListener() {
      Log(this, this.ActivarListener.name);
      eventBus.on('PCVistaVolcarUL_mercanciaVolcada', () => {
        this.NotificarVolcadoDeMercancia();
      });
      eventBus.on('PCVistaVolcarUL_mercanciaTotalVolcada', () => {
        this.NotificarVolcadoDeMercancia();
        f7.views.main.router.back();
      });
      eventBus.on('frmVolcarMercanciaVistaPartida_partidaVolcada', () => { // Evento que provienen de frmVolcarMercanciaVistaPartida
        this.ActualizarComponentPCVistaVolcarUL();
      });
    },
    DesactivarListener() {
      Log(this, this.DesactivarListener.name);
      eventBus.off('PCVistaVolcarUL_mercanciaVolcada');
      eventBus.off('PCVistaVolcarUL_mercanciaTotalVolcada');
      eventBus.off('frmVolcarMercanciaVistaPartida_partidaVolcada');
    },

    ActualizarComponentPCVistaVolcarUL() {
      Log(this, this.ActualizarComponentPCVistaVolcarUL.name);
      this.$refs.PCVistaVolcarUL.ActualizarDatos();
      this.actualizaMercanciaPCVistaVolcarUL = new Date();
    },
    NotificarVolcadoDeMercancia() {
      Log(this, this.NotificarVolcadoDeMercancia.name);
      eventBus.emit('movimientoRealizado');
    },
  },
};
</script>

<style lang="scss">
.icon-unidad-volcado-input {
  margin-top: -10px;
  margin-left: 13px;
  color: green;
}

.texto-calculoCajas {
  color: darkgray;
}

.input-cantidades {
  width: 100%;
}

.navbar-oscuro-1 {
  background-color: var(--his-darkgray);
}
</style>
